<template>
  <div class="bj-section">
    <div class="ubold-title" style="margin-bottom: 40px">资金明细</div>
    <div class="bj-search-section">
      <div class="bj-search-row">
        <div class="item">
          <div class="name" style="margin-right: 10px">交易类型：</div>
          <div class="bj-rows">
            <div :class="['item-radio',{ active: item.value === searchObj.transDetailType }]"
              v-for="item in transDetailTypeList"
              :key="item.value"
              @click="onCheckTransDetailType(item.value)">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="bj-search-row" style="margin-top: 20px;">
        <div class="item">
          <div class="name" style="margin-right: 10px">财务类型：</div>
            <Select
              class="bj-select-h45 bj-bg-color-26262A "
              v-model="searchObj.financeType"
              style="width: 220px"
              clearable
            >
              <Option
                v-for="item in financeTypeData"
                :value="item.type"
                :key="item.type"
                >{{ item.typeName }}</Option
              >
            </Select>
        </div>
        <div class="item" style="margin-left: 40px">
          <div class="name" style="margin: 0 20px">交易时间：</div>
          <DatePicker
            class="bj-bg-color-26262A date-time-h45"
            v-model="searchObj.startAtStr"
            @on-change="handleChange"
            type="daterange"
            placeholder="请输入交易时间"
            style="width: 200px"
            clearable
          ></DatePicker>
        </div>
      </div>
      <div class="bj-search-row" style="margin-top: 20px;">
        <div class="item" style="margin-right: 60px">
          <Input
            class="bj-input-26262A bj-input-h45"
            v-model="searchObj.keywords"
            placeholder="请输入搜索的关键词"
            style="width: 300px"
            clearable
          />
          <Button
            class="bj-search-btn-F85A36"
            type="primary"
            style="margin: 0 20px 0 60px;"
            @click="onSearch"
            >搜索</Button
          >
          <Button
            class="bj-border-F85A36"
            @click="onSearchCancel"
            style="margin-right: 20px"
            >重置</Button
          >
        </div>
      </div>
    </div>
    <div class="bj-table-data">
      <div class="total">搜索结果<span class="count">（{{ searchObj.total }}）</span></div>
      <Table
        class="bj-2F3033-table"
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="transDetailType" slot-scope="{ row }">
          <div>
            {{ row.jylx | status }}
          </div>
        </template>
        <template slot="financeType" slot-scope="{ row }">
          <div>
            {{ row.cwlx }}
          </div>
        </template>
        <template slot="remark" slot-scope="{ row }">
          <div class="table-btn" @click="onShowRemark(row.remarks)">查看备注</div>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          class="pages"
          :current="searchObj.page"
          :total="searchObj.total"
          :page-size="searchObj.limit"
          show-total
          show-sizer
          show-elevator
          @on-change="onPageChange"
          @on-page-size-change="onPageSizeChange"
        />
      </div>
    </div>
    <!-- PUSH备注 -->
    <pushRemarkModal
      :show.sync="pushRemarkModalVisibility"
      :data="remark"
    ></pushRemarkModal>
  </div>
</template>

<script>
import pushRemarkModal from "components/push/pushRemarkModal.vue";
import { financeList, financeTypeList } from "api/user.js";
export default {
  name: "transferoutRecord",
  components: {
    pushRemarkModal,
  },
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "支出";
          break;
        case 1:
          title = "收入";
          break;
        case 2:
          title = "冻结";
          break;
        case 3:
          title = "解冻";
          break;
      }
      return title;
    },
    financeTypeStatus(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "支出";
          break;
        case 1:
          title = "收入";
          break;
        case 2:
          title = "冻结";
          break;
        case 3:
          title = "解冻";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      // 交易状态
      transDetailTypeList: [
        {
          name: "全部",
          value: -1,
        },
        {
          name: "支出",
          value: 0,
        },
        {
          name: "收入",
          value: 1,
        },
        {
          name: "冻结",
          value: 2,
        },
        {
          name: "解冻",
          value: 3,
        },
      ],
      searchObj: {
        transDetailType: -1,
        keywords: "",
        startAtStr: "",
        endAt: "",
        startAt: "",
        financeType: -1,
        page: 1,
        limit: 20,
        total: 0,
      },
      columns: [
        {
          width: 180,
          title: "交易日期",
          align: "center",
          key: "createdTime",
        },
        {
          title: "交易金额",
          align: "center",
          key: "amount",
        },
        {
          title: "历史余额",
          align: "center",
          key: "hisAmount",
        },
        {
          title: "类型",
          align: "center",
          slot: "transDetailType",
        },
        {
          title: "财务类型",
          align: "center",
          slot: "financeType",
        },
        {
          title: "查看备注",
          align: "center",
          slot: "remark",
        },
      ],
      data: [],
      tableLoading: false,
      financeTypeData: [], // 财务类型
      tempFinanceTypeData: [],
      pushRemarkModalVisibility: false,
      remark: "", // 备注内容
    };
  },
  created() {
    this.req_getFinanceTypeList();
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        let params = {
          gjc: this.searchObj.keywords,
          page: this.searchObj.page,
          limit: this.searchObj.limit,
          endTime: this.searchObj.endAt,
          createdTime: this.searchObj.startAt,
        };
        this.searchObj.financeType !== -1 &&
          (params.lx = this.searchObj.financeType);
        this.searchObj.transDetailType !== -1 &&
          (params.state = this.searchObj.transDetailType);
        this.tableLoading = true;
        const { code, data } = await financeList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.searchObj.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.searchObj.page = val;
      this.req_getList();
    },
    // 页大小
    onPageSizeChange(val){
      this.searchObj.limit = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.searchObj = this.$options.data().searchObj;
      this.onPageChange(1);
    },
    // 切换状态
    onCheckTransDetailType(val) {
      this.searchObj.transDetailType = val;
      if (val > 0) {
        this.financeTypeData = this.tempFinanceTypeData.filter((o) => {
          return o.transDetailType === val - 1;
        });
      }
      this.onPageChange(1);
    },
    // 获取财务类型
    async req_getFinanceTypeList() {
      try {
        this.loading = true;
        const { code, data, result } = await financeTypeList();
        this.loading = false;
        if (code === 200 && result) {
          this.financeTypeData = data.map(o => {
            return { typeName: o.n, type : o.t}
          });
          this.tempFinanceTypeData = data.map(o => {
            return { typeName: o.n, type : o.t}
          });
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    // 时间变化
    handleChange(val) {
      this.searchObj.startAtStr = val;
      this.searchObj.startAt = val[0];
      this.searchObj.endAt = val[1];
    },
    // 查看备注
    onShowRemark(val) {
      this.pushRemarkModalVisibility = true;
      this.remark = val;
    },
  },
};
</script>
<style lang="less" scoped>
.bj-search-section{
    background-color: #28292C;
    padding: 30px 28px;
    border-radius: 6px;
    .bj-search-row{
      display: flex;
      .item{
        display: flex;
        align-items: center;
        .name{
          color: #fff;
        }
      }
    }
  }
  .item-radio{
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    cursor: pointer;
    margin-right: 40px;
    border: 1px solid #fff;
    min-width: 100px;
    line-height: 40px;
    text-align: center;
    border-radius: 8px;
    transition: all .3s;
  }
  .item-radio.active {
    color: #fff;
    background-color: #F85A36;
  }
</style>

